import * as yup from "yup";

export const validationSchema = yup.object({
    walletName: yup.string().required("Required"),
    walletKey: yup.string().required("Required"),
    currency: yup.string().required("Required"),
    primaryWallet: yup.boolean(),
    status: yup.boolean(),
    conversionRate: yup.number().typeError("Number Only").required("Required")
});


export const initialValues = {
    walletName: "",
    walletKey: "",
    currency: "",
    primaryWallet: false,
    conversionRate: 1,
    description: "",
    status: true
};